

















































































import { AxiosVue } from '@/AxiosVue'; //
import { ServicioProxy } from '@/config/enums'; //
import config from '@/config/index'; //
import { Component } from 'vue-property-decorator';
import { saveImport } from './fetchReporteSerie';

import { LoadingService } from '@/services/loadingService';

import { PermisoAccionVm } from '@/views/base/PermisoAccionVm';
import { IFuncionalidad } from '@/interfaces/Funcionalidad';

import { utils, writeFileXLSX } from 'xlsx';
import readXlsFile from 'read-excel-file';
import Vue from 'vue';
import { AxiosResponse } from 'axios';
import { MSResponse } from '@/interfaces/MS';
import { ControlPatentesInterfaces } from '@/pantallas/TorreControl/ControlPatentes/controlPatentesInterfaces';

@Component({})
export default class ModalImportar extends Vue {
  fileName: string = '';
  idkey: number = 0;
  file_b64: any = null;
  fileSize: number = 0;
  permisosActuales: PermisoAccionVm[] = [];
  permisosTotales: PermisoAccionVm[] = [];
  destinosPosibles: any = [];
  itemsDelExcel: any = 0;
  formFields: {
    archivo: any;
  } = {
    archivo: {
      label: 'Seleccione Archivo',
      value: '',
    },
  };
  // Globales
  $snotify: any;
  e1: number = 1;
  actual: number = 1;
  btnText: string = 'Continuar';
  btnClass: string = 'btn-continuar';
  dialog: boolean = true;
  clienteId: number = config.getClienteSesion();
  loadingService = new LoadingService();
  btnBloquear: boolean = false;
  warningInactivo: any = '';
  dialogConfirmacion: boolean = false;
  dictionaryFormErrors: any = {};
  disabledAccion: boolean = false;
  mensajeConfirmacion: any = '';
  //Interface
  editedItem: IFuncionalidad = {};
  //controllers
  readonly controller: string = 'funcionalidad';
  readonly controllerAccion: string = 'accion';
  readonly controllerModuloAccion: string = 'ModuloAccion';
  axios: AxiosVue = new AxiosVue(ServicioProxy.GestionUsuario);

  eliminarNombre() {
    this.formFields.archivo.value = '';
  }
  mounted() {}
  async handleClick() {
    this.loadingService.showLoading();
    let data = {
      userId: JSON.parse(window.localStorage.user).id,
      clientId: JSON.parse(window.localStorage.user).clienteDefecto,
      filename: this.fileName == null ? '' : this.fileName,
      fileSize: this.fileSize,
      fileB64: this.file_b64,
    };
    const resultadoValidacion = await this.$validator.validateAll();
    if (resultadoValidacion) {
      const axiosResponse: AxiosResponse<
        MSResponse<ControlPatentesInterfaces>
      > = await saveImport(data);
      const msResponse: any = axiosResponse.data;
      if (msResponse.CODIGO_RESPUESTA == '1') {
        this.$snotify.success('Archivo subido con éxito', {
          timeout: 3000,
        });
        this.fileName = '';
        // this.$emit('modalAsociacionEmit', false);
        this.$emit('modalAsociacionEmit', msResponse.MENSAJE_RESPUESTA);
      } else {
        this.$snotify.error(msResponse.MENSAJE_RESPUESTA, {
          timeout: 3000,
        });
      }
    }
    this.loadingService.hideLoading();
  }
  onFilePicked(e: any) {
    let input = document.getElementById('archivoExcel') as HTMLInputElement;
    this.formFields.archivo.value = input.files[0].name;
    let self = this;
    var tgt = e.target || window.event.srcElement,
      files = tgt.files;
    this.fileName = files[0].name;
    console.log('this.fileName ', this.fileName);
    const allowedExtensions = /\.xlsx$/i;
    if (!allowedExtensions.test(this.fileName)) {
      // El archivo no tiene la extensión .xlsx
      this.$snotify.error('Formato del archivo debe ser xlsx', {
        timeout: 3000,
      });
      return;
    }
    if (FileReader && files && files.length) {
      this.fileSize = files[0].size;
      var fr = new FileReader();

      fr.onload = function() {
        var base64 = fr.result;
        self.file_b64 = base64;
      };
      fr.readAsDataURL(files[0]);
    }
    this.idkey += 1;
  }

  descargarPlantilla() {
    let headers = {
      header: [
        'Código del Producto',
        'Nombre en CRM',
        'Código INET',
        'Descripción Corta',
        'Descripción Larga',
        'Cuenta Ingreso',
        'Cuenta Costo',
        'Clase',
        'Plataforma',
        'Tipo de Equipo',
        'Estado',
        'Glosa',
        'Link',
        'Precio de Instalación en UF',
        'Precio de Monitoreo en UF',
        'Precio de Equipo en UF',
        'Precio de Arriendo en UF',
        'Permitir Arriendo',
        'Visible en Cotizador',
      ],
    };
    let datos: any = [{}];
    const ws = utils.json_to_sheet(datos, headers);
    const wb = utils.book_new();
    utils.book_append_sheet(wb, ws, 'Plantilla');
    writeFileXLSX(wb, 'PlantillaImportarCliente.xlsx');
    this.$snotify.success('Plantilla Excel Generada con éxito', 3000);
  }

  cerrarModal() {
    this.$emit('cerrarModal', false);
  }
}
